import { render, staticRenderFns } from "./promoComparator.vue?vue&type=template&id=35f33954&scoped=true&lang=pug"
import script from "./promoComparator.vue?vue&type=script&lang=js"
export * from "./promoComparator.vue?vue&type=script&lang=js"
import style0 from "./promoComparator.vue?vue&type=style&index=0&id=35f33954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f33954",
  null
  
)

export default component.exports